import api from '@/api'

export default {
  state: {
    requests: []
  },
  mutations: {
    LOAD_SHARE_REQUESTS(state, requests) {
      requests.sort((a, b) => (a.share_request.created_at < b.share_request.created_at ? 1 : a.share_request.created_at > b.share_request.created_at ? -1 : 0))
      state.requests = requests
    },
    ADD_SHARE_REQUEST(state, request) {
      state.requests.push(request)
    },
    UPDATE_SHARE_REQUEST(state, request) {
      if (!request?.id) return
      const index = state.requests.findIndex((s) => s.share_request_id == request.share_request_id)
      // its already in the array update it
      if (index > -1) state.requests.splice(index, 1, request)
      // add it to array
      else state.requests.push(request)
    }
  },
  actions: {
    async loadShareRequests({ commit, state, dispatch }, { params = {}, skipCache = false } = {}) {
      // get list of stories from API
      const _s = await api.newsdesk.getShareRequests(params, skipCache)
      let requests = _s?.data ?? []

      // temp workaround
      // requests = requests.map((s) => ({ ...s, share_request: s.share_request[0] }))
      requests.results.reverse()

      commit('LOAD_SHARE_REQUESTS', requests.results)
      return requests
    },

    async sendShareRequest({ commit, state, dispatch }, data) {
      const _s = await api.newsdesk.addShareRequest(data)
      const request = _s?.data
    },

    async acceptShareRequest({ commit, state, dispatch }, id) {
      const _s = await api.newsdesk.updateShareRequest(id, { response: 'accepted' })
      const request = _s.data
      commit('UPDATE_SHARE_REQUEST', request)
    },

    async denyShareRequest({ commit, state, dispatch }, id) {
      const _s = await api.newsdesk.updateShareRequest(id, { response: 'denied' })
      const request = _s.data
      commit('UPDATE_SHARE_REQUEST', request)
    },

    async retractShareRequest({ commit, state, dispatch }, storyId) {
      return await api.newsdesk.retractShareRequest(storyId)
    },

    async completeShareRequest({ commit, state, dispatch }, id) {
      const _s = await api.newsdesk.updateShareRequest(id, { response: 'complete' })
      const request = _s.data
      commit('UPDATE_SHARE_REQUEST', request)
    },
    async changeToCopyModeShareRequest({ commit, state, dispatch }, { id, mediaAssets }) {
      const _s = await api.newsdesk.updateShareRequest(id, { mode: 'copy', mediaAssets })
      const request = _s.data
      commit('UPDATE_SHARE_REQUEST', request)
      return request
    }
  },
  getters: {
    shareRequests(state) {
      return state.requests
    },
    acceptedShareRequests(state) {
      return state.requests.filter((r) => r.share_request.response == 'accepted')
    },
    deniedShareRequests(state) {
      return state.requests.filter((r) => r.share_request.response == 'denied')
    },
    completedShareRequests(state) {
      return state.requests.filter((r) => r.share_request.response == 'complete')
    }
  }
}
